import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { Icons, SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type TradeDetailBoxSkeletonProps = {}

type AvatarCellProps = {
  direction?: 'rtl' | 'ltr'
}

export const TradeDetailBoxSkeleton: FC<TradeDetailBoxSkeletonProps> = () => (
  <Card
    elevation={0}
    sx={{
      position: 'relative',
      bgcolor: 'background.default',
      px: 5,
    }}
  >
    <CardContent sx={{ px: 5, py: 5, '&:last-child': { pb: 5 } }}>
      <Stack
        direction="row"
        flex={1}
        alignItems="center"
        spacing={2}
        sx={{ pb: 4 }}
      >
        <AvatarCell />
        <Icons.TradeArrow sx={{ color: 'grey.100' }} />
        <AvatarCell direction="ltr" />
      </Stack>
      <Stack direction="row" flex={1} spacing={2}>
        <Skeleton variant="rectangular" width={60} height={96} />
        <Stack
          flex={1}
          justifyContent="space-between"
          sx={{ maxWidth: 'calc(100% - 136px)' }}
        >
          <Stack sx={{ mr: 4 }}>
            <SkeletonText variant="small" numberOfLine={2} lastWidth="50%" />
          </Stack>
          <Stack sx={{ ml: 4 }}>
            <SkeletonText variant="small" numberOfLine={2} lastWidth="50%" />
          </Stack>
        </Stack>
        <Skeleton variant="rectangular" width={60} height={96} />
      </Stack>
    </CardContent>
    <Skeleton variant="rectangular" width="100%" height={1} />
  </Card>
)

const AvatarCell: Cell<AvatarCellProps> = ({ direction = 'rtl' }) => {
  return (
    <Stack
      direction={direction === 'rtl' ? 'row' : 'row-reverse'}
      alignItems="center"
      flex={1}
      spacing={2}
      sx={direction === 'rtl' ? { pr: 5 } : { pl: 5 }}
    >
      <Stack>
        <Skeleton variant="circular" width={28} height={28} />
      </Stack>
      <SkeletonText variant="small" width="100%" />
    </Stack>
  )
}
